import { PAGE_READY, USER_SIGNOUT } from './jigsaw-events';
import * as a from './jigsaw-action';
import {
  CREATE_PAGE_VIEWER,
  DECREASE_ZOOM,
  INCREASE_ZOOM,
  SET_ZOOM_SCALE,
} from './jigsaw-methods';
import { afterLogOut } from '../redux-route/route-actions';
import {
  refreshZoom,
  updateScrolling,
} from '../redux-ui/common/reader/actions';
import { getHighlights } from 'app/api/redux-jigsaw/userdata/highlights/actions';
import { getBookmarks } from 'app/api/redux-jigsaw/userdata/bookmarks/actions';
import { getNotes } from 'app/api/redux-jigsaw/userdata/notes/actions';
import { tryGetAncillaries } from 'app/api/redux-jigsaw/ancillaries/actions';

export const events = {
  [PAGE_READY]: [a.hasNextPage(), a.hasPrevPage(), refreshZoom()],
  [USER_SIGNOUT]: [afterLogOut()],
};

export const methods = {
  [CREATE_PAGE_VIEWER]: [
    a.getToc(),
    getBookmarks(),
    getNotes(),
    getHighlights(),
    a.getThumbnails(),
    updateScrolling(),
    a.getCitation(),
    a.getPageBreaks(),
    tryGetAncillaries(),
  ],
  [SET_ZOOM_SCALE]: [updateScrolling()],
  [INCREASE_ZOOM]: [updateScrolling()],
  [DECREASE_ZOOM]: [updateScrolling()],
};



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/jigsaw-auto-triggers.js